<template>
  <div
    :style="{
      background: getBackgroundColorByStatus(status),
      color: getTextColorByStatus(status)
    }"
  >
    <span v-if="status === 'OK'">
      <v-icon small :color="getTextColorByStatus(status)">mdi-check</v-icon>
    </span>
    <span v-else-if="status === 'ERRO_NAO_CRITICO'">
      <v-icon small :color="getTextColorByStatus(status)">mdi-alert-outline</v-icon>
    </span>
    <span v-else-if="status === 'ERRO_CRITICO'">
      <v-icon small :color="getTextColorByStatus(status)">mdi-close-thick</v-icon>
    </span>
    <span v-else>
      {{ status }}
    </span>
  </div>
</template>
<script>
  import TabelaResultadoValidacaoMixins from './TabelaResultadoValidacaoMixins';
  export default {
    name: 'TabelaResultadoValidacaoDecFec',
    mixins: [TabelaResultadoValidacaoMixins],
    props: {
      status: {
        type: String,
        required: true
      }
    }
  };
</script>
